'use client';

import { useEffect } from 'react';

// Registra uma visita da pagina em chefia/api/v1/visitas.php. Nao mostra nada:
// o total so aparece no painel do chefia (Painel > Visitas de paginas), a API
// publica nem devolve o numero.
export default function RegistrarVisita({ pageKey }: { pageKey: string }) {
  useEffect(() => {
    // Em dev o /api e proxeado para a API de producao (next.config.mjs); so um
    // build de producao pode incrementar, senao teste local inflaria o numero
    // real.
    if (process.env.NODE_ENV !== 'production') return;

    // Uma vez por sessao do navegador: recarregar nao conta de novo.
    const flag = `visita:${pageKey}`;
    try {
      if (sessionStorage.getItem(flag) === '1') return;
    } catch {
      // sessionStorage bloqueado: cai no comportamento de contar a cada carga
    }

    const ctrl = new AbortController();
    fetch('/api/v1/visitas.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: pageKey }),
      signal: ctrl.signal,
    })
      .then((r) => {
        if (!r.ok) return;
        try {
          sessionStorage.setItem(flag, '1');
        } catch {
          // ignora
        }
      })
      .catch(() => {
        // registro e silencioso: falha nao afeta a pagina
      });

    return () => ctrl.abort();
  }, [pageKey]);

  return null;
}
